function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @property {*} data
 * @property {Node} source
 * @property {string} type
 * @property {CustomEvent} domEvent
 */
var AppEvent = /*#__PURE__*/function () {
  /**
   *
   * @param {string} eventType
   * @param {Node} sender
   * @param {*} data
   * @param {boolean} bubbles
   * @param {boolean} cancelable
   */
  function AppEvent(eventType, sender, data) {
    var bubbles = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var cancelable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    _classCallCheck(this, AppEvent);

    this.data = data;
    this.source = sender;
    this.type = eventType;
    this.domEvent = new CustomEvent(eventType, {
      bubbles: bubbles,
      cancelable: cancelable,
      detail: this
    });
  }

  _createClass(AppEvent, [{
    key: "cancel",
    value: function cancel() {
      this.domEvent.stopPropagation();
    }
    /**
     * @param {string} event
     * @param {*} data
     * @param {{bubbles:boolean, cancelable: boolean}} options
     * @param {Element} node
     */

  }], [{
    key: "fire",
    value: function fire(event, data, options, node) {
      node.dispatchEvent(new AppEvent(event, node, data, options.bubbles, options.cancelable).domEvent);
    }
    /**
     * @param {string | Array<string>} event
     * @param {Function} handler
     * @param {Element} node
     */

  }, {
    key: "listen",
    value: function listen(event, handler, node) {
      if (typeof event === 'string') event = [event];
      event.forEach(function (eventType) {
        node.addEventListener(eventType, function (event) {
          return handler(event.detail);
        });
      });
    }
  }, {
    key: "broadcast",
    value: function broadcast(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      document.querySelectorAll('[is]').forEach(function (node) {
        return AppEvent.fire(event, data, {
          bubbles: false,
          cancelable: true
        }, node);
      });
    }
  }]);

  return AppEvent;
}();

export { AppEvent as default };